/* ─────────────────────────────────────────────
   Related products carousel.
   Self-contained and instance-scoped, so several can share a page.
   ───────────────────────────────────────────── */
(function () {
  'use strict';

  function cartApi() {
    try {
      if (typeof LoopCart !== 'undefined' && LoopCart) return LoopCart;
    } catch (e) { /* not defined yet */ }
    return window.LoopCart || null;
  }

  async function addToCart(variantId, quantity) {
    const api = cartApi();
    if (api && typeof api.addItem === 'function') return api.addItem(variantId, quantity);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    });
    if (!res.ok) throw new Error('Failed to add item');
    return res.json();
  }

  function init(root) {
    const track = root.querySelector('[data-elp-related-track]');
    if (!track) return;

    const arrows = root.querySelector('[data-elp-related-arrows]');
    const seeAll = root.querySelector('[data-elp-related-seeall]');
    const dotsWrap = root.querySelector('[data-elp-related-dots]');
    const dots = dotsWrap ? dotsWrap.querySelectorAll('.elp-related__dot') : [];
    const prev = root.querySelector('[data-elp-related-prev]');
    const next = root.querySelector('[data-elp-related-next]');

    function scrollable() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    function update() {
      // Nothing to scroll: the arrows and dots would be decoration only.
      if (!scrollable()) {
        if (arrows) arrows.hidden = true;
        if (seeAll) seeAll.hidden = true;
        if (dotsWrap) dotsWrap.hidden = true;
        return;
      }
      if (dotsWrap) dotsWrap.hidden = false;

      const max = track.scrollWidth - track.clientWidth;
      const ratio = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
      const atEnd = ratio > 0.92;

      if (dots.length) {
        const active = Math.round(ratio * (dots.length - 1));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
      }

      // At the end of the row the arrows give way to "See all", as designed.
      if (seeAll) {
        if (arrows) arrows.hidden = atEnd;
        seeAll.hidden = !atEnd;
      } else if (arrows) {
        arrows.hidden = false;
        if (prev) prev.disabled = ratio <= 0.01;
        if (next) next.disabled = atEnd;
      }
    }

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -260, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: 260, behavior: 'smooth' }));

    // Coalesce scroll work into a frame, but fall back to a direct call:
    // requestAnimationFrame is paused while the document is hidden.
    let ticking = false;
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      const run = function () { ticking = false; update(); };
      if (typeof window.requestAnimationFrame === 'function' && !document.hidden) {
        window.requestAnimationFrame(run);
      } else {
        run();
      }
    }

    track.addEventListener('scroll', requestUpdate, { passive: true });

    window.addEventListener('resize', requestUpdate);
    if ('ResizeObserver' in window) new ResizeObserver(requestUpdate).observe(track);

    root.querySelectorAll('[data-elp-related-atc]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variant;
        if (!variantId || btn.disabled) return;
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        try {
          await addToCart(variantId, 1);
          btn.textContent = 'Added ✓';
          const api = cartApi();
          if (api && typeof api.refreshCount === 'function') {
            try { await api.refreshCount(); } catch (e) { /* non-fatal */ }
          }
          document.dispatchEvent(new Event('cart:open'));
        } catch (err) {
          console.error('Related products — add to cart failed', err);
        }
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1400);
      });
    });

    update();
  }

  document.querySelectorAll('[data-elp-related]').forEach(init);
})();
